import { MARQUEE_TITLES } from "./data";

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {MARQUEE_TITLES.map((title) => (
      <span key={`${title}-${hidden ? "b" : "a"}`} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-2xl italic text-ivory/80 sm:text-3xl">
          {title}
        </span>
        <span className="text-gold" aria-hidden="true">
          ✦
        </span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-gold/25 bg-midnight py-6"
    >
      <div className="animate-marquee flex w-max">
        <Row hidden={false} />
        <Row hidden={true} />
      </div>
    </div>
  );
}
